/**
 * mapBackgrounds — static raster backdrops for maps that render an image
 * behind their territory polygons (MapDef.backgroundImage).
 *
 * Keyed by the MapDef.backgroundImage value. Metro statically analyses these
 * require() calls, so a new backdrop must be added here to be bundled. The
 * PNG must be sized to the map's viewBox (it fills 0,0..width,height).
 */
import type { ImageSourcePropType } from 'react-native'

export const MAP_BACKGROUND_IMAGES: Readonly<Record<string, ImageSourcePropType>> = {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  captureflag: require('../assets/maps/captureflag.png') as ImageSourcePropType,
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  castles: require('../assets/maps/castles.png') as ImageSourcePropType,
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  'atlantis-rising': require('../assets/maps/atlantis-rising.png') as ImageSourcePropType,
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  'crescent-isle': require('../assets/maps/crescent-isle.png') as ImageSourcePropType,
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  'captureflag-walls': require('../assets/maps/captureflag-walls.png') as ImageSourcePropType,
}
